import React from "react";
import ReplceCard from "../assets/ReplceCard.png"

const ReplaceCartModal = ({ setReplaceCard, replaceMyCardFun }) => {
  return (
    <div
      className="modal"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 99999999999999999,
      }}
    >
      <div
        className="modal-content"
        style={{
          position: "relative",
          background: "#fff",
          borderRadius: "12px",
          width: "300px",
          padding: "32px 20px",
          textAlign: "center",
          boxShadow: "0px 4px 25px rgba(0, 0, 0, 0.1)",
          top: "0"        }}
      >
        {/* Top image */}
        <img
          src={ReplceCard}
          alt="Replace Cart"
          style={{
            position: "absolute",
            top: "-41px",
            left: "50%",
            transform: "translateX(-50%)",
            width: "73px",
          }}
        />

        {/* Text Section */}
        <div style={{ marginTop: "20px" }}>
          <h3
            style={{
              color: "#384F6F",
              fontFamily: "Roboto",
              fontSize: "16px",
              fontWeight: "700",
              lineHeight: "28px",
              letterSpacing: "1px",
              marginBottom: "12px",
            }}
          >
            Replace cart items?
          </h3>

          <p
            style={{
              color: "rgba(56, 79, 111, 0.69)",
              fontFamily: "Roboto",
              fontSize: "12px",
              fontWeight: "400",
              lineHeight: "20px",
              margin: "0 0 20px",
            }}
          >
            Your current cart will be cleared when you add items from a
            different vending machine.
          </p>
        </div>

        {/* Buttons */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            marginTop: "3%",
          }}
        >
          <button
            onClick={(e)=>{setReplaceCard(false)}}
            className="no-btn"
            style={{
              width: "108px",
              height: "41px",
             
              borderRadius: "8px",
              border: "2px solid #00b177",
              backgroundColor: "#fff",
              color: "#00b177",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            NO
          </button>

          <button
            onClick={(e)=>{replaceMyCardFun(e)}}
            className="yes-btn"
            style={{
              width: "108px",
              height: "41px",
             
              borderRadius: "8px",
              backgroundColor: "#00b177",
              border:"#00b177",
              color: "#fff",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            YES
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReplaceCartModal;
